import { signOut } from "firebase/auth";
import { auth, db } from "./firebase";
import React, { useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Button from "@mui/material/Button";
import UpgradeIcon from "@mui/icons-material/Upgrade";
import { useNavigate } from "react-router-dom";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Alert from "@mui/material/Alert";
import {
  collection,
  getDocs,
  addDoc,
  doc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";
import Singlecomplaint from "./singlecomplaint";
import CircularProgress, {
  CircularProgressProps,
} from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

//manage

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
function CircularProgressWithLabel(
  props: CircularProgressProps & { value: number }
) {
  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress variant="determinate" {...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="caption"
          component="div"
          color="text.secondary"
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}
function Allcomplaints_admin() {
  const [Allcomplaints_admin, setAllcomplaints_admin] = useState([]);
  const [show_complaints, set_show_complaints] = useState([]);
  const [admin_view, set_admin_view] = useState("all_comp");
  const comref = collection(db, "Complaints");

  const ssd = async () => {
    getDocs(comref).then((response) => {
      let complaints = [];
      response.docs.map((item) => {
        let a = item.data();
        a = { ...a, id: item.id };

        complaints = [...complaints, a];
      });

      const fgh = complaints.sort((x, y) => {
        return new Date(y.Date_of_complaint) - new Date(x.Date_of_complaint);
      });

      setAllcomplaints_admin(fgh);
      set_show_complaints(fgh);
    });
  };

  useEffect(() => {
    ssd();
  }, []);

  //manage
  const depart = [
    "Electrical Engineering",
    "Civil Engineering",
    "Electronics and Communication Engineering",
    "Computer Science Engineering",
    "Mechanical Engineering",
  ];
  const colref = collection(db, "Users");
  const [clicked, setclicked] = useState("none");
  const [dep, setdep] = useState("User's Department");
  const [dep2, setdep2] = useState("User's Department");
  const [seluser, setseluser] = useState("User's name");
  const [newname, setnewname] = useState("Name");
  const [newid, setnewid] = useState("Email-id");

  const [u1, setu1] = useState([{ Name: "Select department first" }]);

  function uclick(nm) {
    setseluser(nm);
  }

  function hclick(branch, i) {
    if (i == "1") {
      setdep(branch);
    } else if (i == "2") {
      setdep2(branch);
    }
    const x = [];

    getDocs(colref).then((response) => {
      response.docs.map((item) => {
        const a = { ...item.data(), id: item.id };

        if (a.Department === branch) x.push(a);
      });

      setu1(x);
    });
  }
  const [flag, setflag] = useState(false);
  function handleclick2() {
    if (newid.slice(newid.length - 11, newid.length) === "@nitp.ac.in") {
      const colref = collection(db, "Users");
      getDocs(colref).then((response) => {
        response.docs.map((item) => {
          const a = { ...item.data(), id: item.id };

          if (a.Department === dep2 && a.Name === newname && a.Email === newid)
            setflag(true);
        });
      });

      if (flag === false) {
        addDoc(colref, {
          Department: dep2,
          Name: newname,
          Email: newid,
        });

        setclicked("success");
        setdep2("User's Department");
        setnewname("Name");
        setnewid("Email-id");
      } else {
        setclicked("success2");
        setdep2("User's Department");
        setnewname("Name");
        setnewid("Email-id");
      }
    } else {
      setclicked("error");
    }
  }
  async function handleclick(event) {
    event.preventDefault();

    const b = u1.filter(function (item) {
      return item.Name === seluser;
    });
    const mail = b[0].Email;
    const username = b[0].Name;
    const userid = b[0].id;

    await deleteDoc(doc(db, "Users", userid));

    setclicked("success3");
    setdep("User's Department");
    setseluser("User's name");
  }

  function handlec2(event) {
    const { name, value } = event.target;
    if (name == "nme") {
      setnewname(value);
    } else if (name == "ide") {
      setnewid(value);
    }
  }

  //const for single complaint page
  const [getcomplaint, setgetcomplaint] = useState({
    location: "",
    date_time: "",
    typeofcomplaint: "",
    description: "",
    statusofcomplaint: "",
    idofcomplaint: "",
    nameofuser: "",
    contactofuser: "",
  });

  const [progress_counter, set_progress_counter] = useState();
  const [admin_look, set_admin_look] = useState("complaints");
  const [sort_filter, setsort_filter] = useState({
    sort_type: "Newest",
    filter_complaint_type: "All complaints",
    filter_complaint_status: "All complaints",
  });

  function handlesort(event) {
    const { name, value } = event.target;
    setsort_filter((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  }
  const [value, setValue] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  function fsd() {
    if (loading) return;
    setLoading(true);
    const frankDocRef = doc(db, "Complaints", getcomplaint.idofcomplaint);

    var newstatus = "";
    if (getcomplaint.statusofcomplaint === "Registered") {
      newstatus = "Considered";
      set_progress_counter("50");
    } else if (getcomplaint.statusofcomplaint === "Considered") {
      newstatus = "In Progress";
      set_progress_counter("75");
    } else if (getcomplaint.statusofcomplaint === "In Progress") {
      newstatus = "Resolved";
      set_progress_counter("100");
    }
    // To update age and favorite color:

    updateDoc(frankDocRef, {
      Status_of_complaint: newstatus,
    });
    setgetcomplaint((prev) => {
      return {
        ...prev,
        statusofcomplaint: newstatus,
      };
    });
    //call made to db to get updated statuses of complaints

    ssd();
    setclicked("success4");
    setLoading(false);
  }
  const [valueq, setValueq] = useState("one");

  const handleChange = (event, newValue) => {
    setValueq(newValue);
  };
  //for setting single complaint to be shown and setting view accordingly
  function eachcomplaint(onecomplaint) {
    if (onecomplaint.Status_of_complaint === "Registered") {
      set_progress_counter("25");
    } else if (onecomplaint.Status_of_complaint === "Considered") {
      set_progress_counter("50");
    } else if (onecomplaint.Status_of_complaint === "In Progress") {
      set_progress_counter("75");
    } else if (onecomplaint.Status_of_complaint === "Resolved") {
      set_progress_counter("100");
    }
    const pop = {
      location: onecomplaint.Location_of_complaint,
      date_time: onecomplaint.Date_of_complaint,
      typeofcomplaint: onecomplaint.Type_of_complaint,
      description: onecomplaint.Description_of_complaint,
      statusofcomplaint: onecomplaint.Status_of_complaint,
      idofcomplaint: onecomplaint.id,
      nameofuser: onecomplaint.Name_of_user,
      contactofuser: onecomplaint.Contact_of_user,
    };

    setgetcomplaint((prev) => {
      return {
        ...prev,
        ...pop,
      };
    });

    handleview("one_comp");
  }

  //handling view
  function handleview(s) {
    if (s === "all_comp") {
      applyfilter();
    } else {
      set_admin_view(s);
    }
  }

  function applyfilter() {
    var cd = Allcomplaints_admin;
    if (sort_filter.filter_complaint_type != "All complaints") {
      cd = Allcomplaints_admin.filter((item) => {
        return item.Type_of_complaint === sort_filter.filter_complaint_type;
      });
    }

    if (sort_filter.filter_complaint_status != "All complaints") {
      cd = cd.filter((item) => {
        return item.Status_of_complaint === sort_filter.filter_complaint_status;
      });
    }

    if (value != null) {
      let date = new Date(value).getDate();
      let month = new Date(value).getMonth();
      let year = new Date(value).getFullYear();
      cd = cd.filter((item) => {
        return (
          new Date(item.Date_of_complaint).getDate() === date &&
          new Date(item.Date_of_complaint).getMonth() === month &&
          new Date(item.Date_of_complaint).getFullYear() === year
        );
      });
    }

    if (sort_filter.sort_type === "Oldest") {
      cd = cd.sort((x, y) => {
        return new Date(x.Date_of_complaint) - new Date(y.Date_of_complaint);
      });
    } else {
      cd = cd.sort((x, y) => {
        return new Date(y.Date_of_complaint) - new Date(x.Date_of_complaint);
      });
    }
    set_show_complaints(cd);
    if (cd.length === 0) {
      handleview("no_comp");
    } else {
      set_admin_view("all_comp");
    }
  }
  const navigate = useNavigate();
  const handleadminLogOut = async () => {
    signOut(auth)
      .then(() => {
        // Sign-out successful.
        window.localStorage.removeItem("token");
        navigate("/adminlogin");
      })
      .catch((error) => {
        // An error happened.
      });
  };

  if (admin_look === "complaints") {
    if (admin_view === "all_comp") {
      return (
        <div className="container mt-1">
          <div style={{ backgroundColor: "#343a40" }}>
            <nav class="navbar navbar-expand-lg navbar-dark">
              <a class="navbar-brand" href="http://nitp.ac.in/">
                <img
                  src="https://nitp.ac.in/static/logo512-579d034908ae89b5e0243d1274937d5d.png"
                  alt=""
                  width="30"
                  height="24"
                  margin-right="100"
                  class="d-inline-block align-text-top"
                />
                Nit Patna complaint portal
              </a>
              <button
                class="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span class="navbar-toggler-icon"></span>
              </button>
              <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav ml-auto">
                  <li class="nav-item">
                    <button
                      className="btn btn-outline-info"
                      onClick={() => set_admin_look("complaints")}
                    >
                      Complaints
                    </button>
                  </li>
                  <li class="nav-item">
                    <button
                      className="btn btn-link"
                      onClick={() => set_admin_look("manage")}
                    >
                      Manage users
                    </button>
                  </li>
                  <li class="nav-item">
                    <button
                      className="btn btn-outline-success"
                      onClick={handleadminLogOut}
                    >
                      Log out
                    </button>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
          <div class="row mt-4">
            <div class="col-md-2">
              <Box sx={{ minWidth: 120 }} pb={3}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Sort by</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="sort_type"
                    value={sort_filter.sort_type}
                    label="Sort by"
                    onChange={handlesort}
                  >
                    <MenuItem value="Newest">Newest</MenuItem>
                    <MenuItem value="Oldest">Oldest</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </div>
            <div class="col-md-2">
              <Box sx={{ minWidth: 120 }} pb={3}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Filter by type
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="filter_complaint_type"
                    value={sort_filter.filter_complaint_type}
                    label="Filter by type"
                    onChange={handlesort}
                  >
                    <MenuItem value="Academic">Academic complaints</MenuItem>
                    <MenuItem value="Administration">
                      Administration complaints
                    </MenuItem>
                    <MenuItem value="Residential">
                      Residential complaints
                    </MenuItem>
                    <MenuItem value="All complaints">All complaints</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </div>
            <div class="col-md-3">
              <Box sx={{ minWidth: 120 }} pb={3}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Filter by status of complaint
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="filter_complaint_status"
                    value={sort_filter.filter_complaint_status}
                    label="Filter by status of complaint"
                    onChange={handlesort}
                  >
                    <MenuItem value="Resolved">Resolved complaints</MenuItem>
                    <MenuItem value="In Progress">
                      Complaints in progress
                    </MenuItem>
                    <MenuItem value="Registered">
                      Registered complaints
                    </MenuItem>
                    <MenuItem value="Considered">
                      Considered complaints
                    </MenuItem>
                    <MenuItem value="All complaints">All complaints</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </div>
            <div class="col-md">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Filter by date"
                  value={value}
                  onChange={(newValue) => {
                    setValue(newValue);
                  }}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </div>
            <div class="col-md">
              <button class="btn btn-outline-success" onClick={applyfilter}>
                Apply filters
              </button>
            </div>
          </div>
          {show_complaints.map((onecomp) => {
            return (
              <div class="container mt-4">
                <div class="card">
                  <h5 class="card-header">
                    Registered on:{" "}
                    {new Date(onecomp.Date_of_complaint)?.toDateString()}
                  </h5>
                  <div class="card-body">
                    <h5 class="card-title">
                      Location of complaint: {onecomp.Location_of_complaint}
                    </h5>
                    <p>Name of user: {onecomp.Name_of_user}</p>
                    <p>Contact of user: {onecomp.Contact_of_user}</p>
                    <p class="card-text">
                      Type of complaint: {onecomp.Type_of_complaint}
                    </p>

                    <p
                      class="btn btn-outline-success"
                      onClick={() => eachcomplaint(onecomp)}
                    >
                      See details
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      );
    }
    if (admin_view === "no_comp") {
      return (
        <div className="container mt-1">
          <div style={{ backgroundColor: "#343a40" }}>
            <nav class="navbar navbar-expand-lg navbar-dark">
              <a class="navbar-brand" href="http://nitp.ac.in/">
                <img
                  src="https://nitp.ac.in/static/logo512-579d034908ae89b5e0243d1274937d5d.png"
                  alt=""
                  width="30"
                  height="24"
                  margin-right="100"
                  class="d-inline-block align-text-top"
                />
                Nit Patna complaint portal
              </a>
              <button
                class="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span class="navbar-toggler-icon"></span>
              </button>
              <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav ml-auto">
                  <li class="nav-item">
                    <button
                      className="btn btn-outline-info"
                      onClick={() => set_admin_look("complaints")}
                    >
                      Complaints
                    </button>
                  </li>
                  <li class="nav-item">
                    <button
                      className="btn btn-link"
                      onClick={() => set_admin_look("manage")}
                    >
                      Manage users
                    </button>
                  </li>
                  <li class="nav-item">
                    <button
                      className="btn btn-outline-success"
                      onClick={handleadminLogOut}
                    >
                      Log out
                    </button>
                  </li>
                </ul>
              </div>
            </nav>
          </div>

          <div class="row mt-4">
            <div class="col-md-2 ">
              <Box sx={{ minWidth: 120 }} pb={3}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Sort by</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="sort_type"
                    value={sort_filter.sort_type}
                    label="Sort by"
                    onChange={handlesort}
                  >
                    <MenuItem value="Newest">Newest</MenuItem>
                    <MenuItem value="Oldest">Oldest</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </div>

            <div class="col-md-2">
              <Box sx={{ minWidth: 120 }} pb={3}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Filter by type
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="filter_complaint_type"
                    value={sort_filter.filter_complaint_type}
                    label="Filter by type"
                    onChange={handlesort}
                  >
                    <MenuItem value="Academic">Academic complaints</MenuItem>
                    <MenuItem value="Administration">
                      Administration complaints
                    </MenuItem>
                    <MenuItem value="Residential">
                      Residential complaints
                    </MenuItem>
                    <MenuItem value="All complaints">All complaints</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </div>
            <div class="col-md-3">
              <Box sx={{ minWidth: 120 }} pb={3}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Filter by status of complaint
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="filter_complaint_status"
                    value={sort_filter.filter_complaint_status}
                    label="Filter by status of complaint"
                    onChange={handlesort}
                  >
                    <MenuItem value="Resolved">Resolved complaints</MenuItem>
                    <MenuItem value="In Progress">
                      Complaints in progress
                    </MenuItem>
                    <MenuItem value="Registered">
                      Registered complaints
                    </MenuItem>
                    <MenuItem value="Considered">
                      Considered complaints
                    </MenuItem>
                    <MenuItem value="All complaints">All complaints</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </div>
            <div class="col-md">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Filter by date"
                  value={value}
                  onChange={(newValue) => {
                    setValue(newValue);
                  }}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </div>
            <div class="col-md">
              <button class="btn btn-outline-success" onClick={applyfilter}>
                Apply filters
              </button>
            </div>
          </div>
          <div className="container mt-3" style={{ textAlign: "center" }}>
            <h3>No such complaints</h3>
          </div>
        </div>
      );
    }
    if (admin_view === "one_comp") {
      return (
        <div className="container mt-1">
          <div style={{ backgroundColor: "#343a40" }}>
            <nav class="navbar navbar-expand-lg navbar-dark">
              <a class="navbar-brand" href="http://nitp.ac.in/">
                <img
                  src="https://nitp.ac.in/static/logo512-579d034908ae89b5e0243d1274937d5d.png"
                  alt=""
                  width="30"
                  height="24"
                  margin-right="100"
                  class="d-inline-block align-text-top"
                />
                Nit Patna complaint portal
              </a>
              <button
                class="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span class="navbar-toggler-icon"></span>
              </button>
              <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav ml-auto">
                  <li class="nav-item">
                    <button
                      className="btn btn-outline-info"
                      onClick={() => set_admin_look("complaints")}
                    >
                      Complaints
                    </button>
                  </li>
                  <li class="nav-item">
                    <button
                      className="btn btn-link"
                      onClick={() => set_admin_look("manage")}
                    >
                      Manage users
                    </button>
                  </li>
                  <li class="nav-item">
                    <button
                      className="btn btn-outline-success"
                      onClick={handleadminLogOut}
                    >
                      Log out
                    </button>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
          <div className="container mt-1">
            <div class="card">
              <h5 class="card-header">
                <ArrowBackIcon onClick={() => handleview("all_comp")} />
                Registered on:
                {new Date(getcomplaint.date_time)?.toDateString()}
              </h5>
              <div class="card-body">
                <p class="card-text">Raised by : {getcomplaint.nameofuser}</p>
                <p class="card-text">
                  Contact no : {getcomplaint.contactofuser}
                </p>
                <p class="card-text">
                  Location of complaint: {getcomplaint.location}
                </p>
                <p class="card-text">
                  Type of complaint: {getcomplaint.typeofcomplaint}
                </p>
                <p class="card-text">Description: {getcomplaint.description}</p>
                <p class="card-text">
                  current status: {getcomplaint.statusofcomplaint}
                </p>
                <CircularProgressWithLabel value={progress_counter} />
                <br></br>

                <Button
                  variant="contained"
                  onClick={fsd}
                  disabled={loading || progress_counter === "100"}
                >
                  UPDATE STATUS
                  <UpgradeIcon />
                </Button>
              </div>
            </div>
            <div
              style={{
                visibility: clicked === "success4" ? "visible" : "hidden",
              }}
            >
              <Alert onClose={() => setclicked("none")}>
                Updated successfully!
              </Alert>
            </div>
          </div>
        </div>
      );
    }
  }
  if (admin_look === "manage") {
    return (
      <div className="container mt-1">
        <div style={{ backgroundColor: "#343a40" }}>
          <nav class="navbar navbar-expand-lg navbar-dark">
            <a class="navbar-brand" href="http://nitp.ac.in/">
              <img
                src="https://nitp.ac.in/static/logo512-579d034908ae89b5e0243d1274937d5d.png"
                alt=""
                width="30"
                height="24"
                margin-right="100"
                class="d-inline-block align-text-top"
              />
              Nit Patna complaint portal
            </a>
            <button
              class="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav ml-auto">
                <li class="nav-item">
                  <button
                    className="btn btn-outline-info"
                    onClick={() => set_admin_look("complaints")}
                  >
                    Complaints
                  </button>
                </li>
                <li class="nav-item">
                  <button
                    className="btn btn-link"
                    onClick={() => set_admin_look("manage")}
                  >
                    Manage users
                  </button>
                </li>
                <li class="nav-item">
                  <button
                    className="btn btn-outline-success"
                    onClick={handleadminLogOut}
                  >
                    Log out
                  </button>
                </li>
              </ul>
            </div>
          </nav>
        </div>

        <Box sx={{ width: "100%" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={valueq}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab label="Add " {...a11yProps(0)} />

              <Tab label="Delete " {...a11yProps(1)} />
            </Tabs>
          </Box>
          <TabPanel value={valueq} index={0}>
            <div class="container mt-4">
              <label for="exampleFormControlInput1" class="form-label">
                Department
              </label>
              <div class="input-group mb-3">
                <input
                  type="text"
                  class="form-control"
                  aria-label="Text input with dropdown button"
                  value={dep2}
                />
                <button
                  class="btn btn-outline-secondary dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                ></button>
                <ul class="dropdown-menu dropdown-menu-end">
                  {depart.map((branch) => (
                    <li>
                      <a
                        class="dropdown-item"
                        href="#"
                        value={branch}
                        onClick={() => hclick(branch, "2")}
                      >
                        {branch}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <label for="exampleFormControlInput1" class="form-label">
                Name
              </label>
              <div class="input-group mb-3">
                <input
                  type="text"
                  name="nme"
                  class="form-control"
                  aria-label="Text input with dropdown button"
                  value={newname}
                  onChange={handlec2}
                />
              </div>

              <label for="exampleFormControlInput1" class="form-label">
                Email id
              </label>
              <div class="input-group mb-3">
                <input
                  type="text"
                  name="ide"
                  class="form-control"
                  aria-label="Text input with dropdown button"
                  value={newid}
                  onChange={handlec2}
                />
              </div>

              <button
                type="button"
                class="btn btn-dark"
                disabled={
                  dep2 === "Your Department" ||
                  newname === "Name" ||
                  newid === "Email-id"
                }
                onClick={handleclick2}
              >
                Add user
              </button>
              <div
                style={{
                  visibility: clicked === "success" ? "visible" : "hidden",
                }}
              >
                <Alert onClose={() => setclicked("none")}>
                  Task done successfully!
                </Alert>
              </div>
              <div
                style={{
                  visibility: clicked === "success2" ? "visible" : "hidden",
                }}
              >
                <Alert onClose={() => setclicked("none")}>User exists!</Alert>
              </div>
              <div
                style={{
                  visibility: clicked === "error" ? "visible" : "hidden",
                }}
              >
                <Alert severity="error" onClose={() => setclicked("none")}>
                  Enter correct mail id!
                </Alert>
              </div>
            </div>
          </TabPanel>

          <TabPanel value={valueq} index={1}>
            <div class="container mt-4">
              <label for="exampleFormControlInput1" class="form-label">
                Department
              </label>
              <div class="input-group mb-3">
                <input
                  type="text"
                  class="form-control"
                  aria-label="Text input with dropdown button"
                  value={dep}
                />
                <button
                  class="btn btn-outline-secondary dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                ></button>
                <ul class="dropdown-menu dropdown-menu-end">
                  {depart.map((branch) => (
                    <li>
                      <a
                        class="dropdown-item"
                        href="#"
                        value={branch}
                        onClick={() => hclick(branch, "1")}
                      >
                        {branch}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <label for="exampleFormControlInput1" class="form-label">
                Name
              </label>
              <div class="input-group mb-3">
                <input
                  type="text"
                  class="form-control"
                  aria-label="Text input with dropdown button"
                  value={seluser}
                />
                <button
                  class="btn btn-outline-secondary dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                ></button>
                <ul class="dropdown-menu dropdown-menu-end">
                  {u1.map((i) => (
                    <li>
                      <a
                        class="dropdown-item"
                        href="#"
                        value={i.Name}
                        onClick={() => uclick(i.Name)}
                      >
                        {i.Name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              <button
                type="button"
                class="btn btn-dark"
                disabled={
                  dep === "User's Department" || seluser === "User's name"
                }
                onClick={handleclick}
              >
                Delete user
              </button>
              <div
                style={{
                  visibility: clicked === "success3" ? "visible" : "hidden",
                }}
              >
                <Alert onClose={() => setclicked("none")}>
                  Task done successfully!
                </Alert>
              </div>
            </div>
          </TabPanel>
        </Box>
      </div>
    );
  }
}

export default Allcomplaints_admin;
